import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { parse } from '../utils/parseQuery';
import SignalR from '../signalr/signalr';
import config from '../../run-config';

let counter = 300;
const queryParams = parse(window.location.search);

class Signage extends Component {
  constructor(props) {
    super(props);

    this.renderOrder = this.renderOrder.bind(this);
    this.renderOrderGroup = this.renderOrderGroup.bind(this);
  }

  componentDidMount() {
    const {
      match,
      loadLocation,
      loadOrders,
    } = this.props;

    const locationId = match.params.locationId;

    loadLocation(locationId);
    loadOrders(locationId, null, !!queryParams.eventupdate || !!queryParams.headline);

    if (!!queryParams.eventupdate) {
      setInterval(() => {
        if (counter > 0) {
          loadOrders(locationId, null, true);
          counter = counter - 1;;
        }
        
      }, 25000);
    }

    // needed for automatic window movement - do not remove or change.
    document.title = 'signage';
  }

  get whitelabelOptions() {
    const { location } = this.props;
    if (!location || !location.whitelabelOptions) {
      return {};
    }

    try {
      const { kiosk } = JSON.parse(location.whitelabelOptions);

      return kiosk || {};
    } catch (error) {
      // ignore invalid JSON
    }

    return {};
  }

  get emptyBackgroundUrl() {
    const { locationID } = this.props.location;

    const { waitingListBackgroundNoOrdersUrl } = this.whitelabelOptions;

    if (waitingListBackgroundNoOrdersUrl) {
      return waitingListBackgroundNoOrdersUrl;
    }


    //legacy
    if (locationID === 7542) {
      return `${process.env.PUBLIC_URL}/backgrounds/kulinario/idle.jpg`;
    }

    if (locationID === 8915) {
      return `${process.env.PUBLIC_URL}/backgrounds/kaltenhausen/idle.jpg`;
    }

    return `${process.env.PUBLIC_URL}/backgrounds/bobo_idle.jpg`;
  }

  get backgroundUrl() {
    const { waitingListBackgroundUrl } = this.whitelabelOptions;

    if (queryParams.headline && queryParams.headline.toLowerCase().includes('gebäck')) {
      return  `${process.env.PUBLIC_URL}/backgrounds/bistrobox/gebaeck.gif`;
    }

    if (waitingListBackgroundUrl) {
      return waitingListBackgroundUrl;
    }

    const { locationID } = this.props.location;

    let videoPath = `${process.env.PUBLIC_URL}/backgrounds/bobo2.jpg`;

    if (locationID == 8915) {
      videoPath = `${process.env.PUBLIC_URL}/backgrounds/kaltenhausen/active.jpg`;
    }

    if (locationID == 7542) {
      videoPath = `${process.env.PUBLIC_URL}/backgrounds/kulinario/active.jpg`;
    }

    return videoPath;
  }

  renderOrder(order, group) {
    if (!order) {
      return null;
    }

    const { classes, match } = this.props;

    let color = this.whitelabelOptions.signageTextColor;
    let fontFamily = this.whitelabelOptions.signageOrderFontFamily;
    let fontSize = this.whitelabelOptions.preferPickupNumberForSignage ? 140 : undefined;

    const singleItem = group.visibleItemCount == 1;

    let marginTop = undefined;
    let fontWeight = undefined;

    const { locationId } = match.params;

    if (group && singleItem) {
      fontSize = 300;
      marginTop = '-30px';
      fontWeight = 'bold';

      if ((locationId === '10868' || locationId === '7567' || locationId === '12119') && singleItem) {
        marginTop = '-120px';
      }
    } else if (locationId === '10868' || locationId === '7567' || locationId === '12119') {
      fontSize = 100;
       marginTop = '-10px';
    }

    if (locationId === '10797') {
      fontSize = 100;
    }
    
    const className = singleItem 
      ? classes.largeText 
      : classes.text;

    let descriptionFontSize = 40;
    if (group.isOrderCancelled) {
      color = this.whitelabelOptions.signageErrorTextColor;
      fontSize = 150;

      if (locationId === '10868' || locationId === '7567' || locationId === '12119') {
        marginTop = '-150px';
        fontSize = 90;
        descriptionFontSize = 30;
      }
    }

    return (
      <div className={singleItem ?  classes.largeName : classes.name} key={order.orderId}>
        <Typography variant="h5" className={className} style={{ color, fontSize, fontWeight, marginTop, fontFamily }} gutterBottom>
          {this.whitelabelOptions.preferPickupNumberForSignage 
            ? order.pickupNumber 
            : (order.pickupName || order.pickupNumber)}
          {(group.isOrderCancelled && group.displayName) ? ` ${group.displayName}` : null}
        </Typography>
        {group.description ? 
          (<Typography variant="h4" style={{ color, fontSize: descriptionFontSize }} >
            {group.description}
          </Typography>)
          : null
        }
      </div>
    );
  }

  renderOrderGroup(group, index) {
    const { classes, match } = this.props;

    const { locationId } = match.params;

    let headlineStyle = { 
      color: this.whitelabelOptions.signageHeaderTextColor,
      fontFamily: this.whitelabelOptions.signageFontFamily,      
    };
    let columnStyle = null;

    if (this.props.orderGroups.length === 2 && index === 1) {
      headlineStyle = { 
        direction: 'rtl', 
        color: this.whitelabelOptions.signageHeaderTextColor, 
        fontFamily: this.whitelabelOptions.signageFontFamily,        
      };
      columnStyle = { paddingLeft: locationId === '7335' ? 90 : 60 };
    }    

    const renderGroupHeadline = this.whitelabelOptions.hideSignageGroupNames;
    
    if (group.orders.length == 0 && group.visibleItemCount == 1) {
      return null;
    }


    return (
      <div className={classes.column} key={group.name} style={columnStyle}>
        {renderGroupHeadline ? 
        null
        : (
          <Typography variant="h4" 
            className={classes.headline} 
            style={headlineStyle} 
            gutterBottom>
            {group.name}
          </Typography>
        )}
        

        <div className={(locationId === '10868' || locationId === '7567' || locationId === '12119') && group.visibleItemCount != 1 ? classes.namesLargeMarginTop : classes.names}>
          {group.orders && group.orders.map(o => this.renderOrder(o, group))}
        </div>
      </div>
    );
  }

  renderBackground() {
    return (
      <img src={this.backgroundUrl} id="videoBackground" alt="background screen" />
    );
  }

  renderEmptyState(location) {
    const { classes } = this.props;
    const { locationID } = location;

    if (locationID === '747') {
      return (
        <div className={classes.placeholder}>
          <h1>Haubis App</h1>
          <h2>Vorab bestellen. Nicht warten.</h2>
          <h2>App herunterladen.</h2>
        </div>
      );
    }

    return (
      <div className={classes.wrapper}>        
        <img src={this.emptyBackgroundUrl} id="videoBackground" alt="idle screen" />
        {this.renderHeadline()}
      </div>
    )
  }

  renderFocusedUser(orderGroups) {
    const { hideFocusedUser } = this.whitelabelOptions;

    if (hideFocusedUser) {
      return null;
    }

    const secondGroup = orderGroups[1];

    return this.renderHeadline(secondGroup && secondGroup.orders[0] && secondGroup.orders[0].pickupName);
  }

  renderHeadline(headline = '') {
    const { classes } = this.props;
    const fontFamily = this.whitelabelOptions.signageFontFamily;

    return (
      <div className={classes.focusBox}>
        <Typography variant="h1" 
          style={{ 
            fontFamily, 
            fontWeight: fontFamily ? 'normal' : undefined,
            fontSize: this.whitelabelOptions.signageHeaderFontSize,
          }}
          className={queryParams.headline ? classes.customFocusText : classes.focusText} 
          gutterBottom>
          {queryParams && queryParams.headline 
            ? queryParams.headline 
            : headline}
        </Typography>
      </div>
    );
  }

  renderSignalR() {
    const { match, loadOrders } = this.props;
    const locationId = match.params.locationId;

    if (!queryParams.eventupdate && !queryParams.headline && (locationId !== '10797' && locationId !== '10360' && locationId !== '10868' && locationId !== '7567'  && locationId !== '12119')) {
      return null;
    }
    
    return (
      <SignalR
          setSignalRState={() => {}}
          connectionHub={`${config.apiHost}/signalr`}
          locationId={locationId}
          accessToken={'eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6ImU2MzZiOWM1LTE3MGUtNGRmMy1hZGY3LTMwODk0YTkzMTM0NSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL25hbWUiOiJtbEBhcHJvLmF0IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS9hY2Nlc3Njb250cm9sc2VydmljZS8yMDEwLzA3L2NsYWltcy9pZGVudGl0eXByb3ZpZGVyIjoiQVNQLk5FVCBJZGVudGl0eSIsIkFzcE5ldC5JZGVudGl0eS5TZWN1cml0eVN0YW1wIjoiNjNiNDVhOWYtZjJjMy00MzkzLTgxMTktZjQ3ZDgzMWE4NTI4IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjpbIkN1c3RvbWVyIiwiQ3VzdG9tZXIiLCJSZXBvcnRzIiwiQWRtaW4iLCJTdXBlckFkbWluIiwiUmVwb3J0c0FkdmFuY2VkIiwiVXNlciJdLCJuYmYiOjE3NDA1NTUwOTQsImV4cCI6MTc0MTc2NDY5NCwiaXNzIjoibG9jYWxob3N0IiwiYXVkIjoiYWxsIn0.z-1xfGcHvV6GjGuzbWrY3yPY2UYkpJNqpZYkmeA7odE'}
          orderUpdated={(order) => {
            console.log('order', order);            

            loadOrders(locationId, null, true);
          }}
        />
    );
  }

  renderContent() {
    const { classes, orderGroups, location } = this.props;

    if (!orderGroups || !location || !location.locationID) {
      return null;
    }

    if (!this.props.ordersPresent && !queryParams.forceNotEmpty) {
      return this.renderEmptyState(location);
    }

    if (location.locationID === '7542') {
      if (!orderGroups.length) {
        return null;
      }

      return (
        <div className={classes.wrapper}>
          {this.renderBackground()}
          <div className="signage-content">
            <div style={{ marginTop: 320, marginLeft: 50 }}>
              {orderGroups[0].orders.map(order => (
                <div className={classes.name} key={order.orderId}>
                  <Typography variant="h3" className={classes.text} style={{ color: '#969c7d', fontSize: '60px' }} gutterBottom>
                    {order.pickupNumber}
                  </Typography>
                </div>
              ))}
            </div>
            <div style={{ top: 100, right: 30, position: 'absolute', width: '400px', textAlign: 'center' }}>
              {orderGroups[1].orders.map(order => (
                <div className={classes.name} key={order.orderId}>
                  <Typography variant="h3" className={classes.text} style={{ color: '#fff', fontSize: '60px' }} gutterBottom>
                    {order.pickupNumber}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }


    return (
      <div className={classes.wrapper}>
        {this.renderBackground(location)}        
        <div className="signage-content">
          {this.renderFocusedUser(orderGroups)}
          <Grid
            container
            direction="row"
            alignItems="stretch"
            justify="flex-start"
            wrap="nowrap"
            className={classes.content}
          >
            {orderGroups.map(this.renderOrderGroup)}
          </Grid>
        </div>
      </div>
    );
  }

  render() {
    return (
      <>
        {this.renderContent()}
        {this.renderSignalR()}
      </>      
    )
  }
}

Signage.propTypes = {
  orderGroups: PropTypes.array,
  ordersPresent: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  loadOrders: PropTypes.func.isRequired,
  loadLocation: PropTypes.func.isRequired,
  match: PropTypes.any.isRequired,
  location: PropTypes.object.isRequired,
};

Signage.defaultProps = {
  loggedIn: false,
  orderGroups: null,
  ordersPresent: false,
};

const styles = () => ({
  wrapper: {
    backgroundColor: '#010001',
    height: '100vh',
    position: 'absolute',
    color: '#fff',
    padding: '40px',
    width: '100%',
    overflow: 'hidden',
  },
  content: {
    height: '65vh',
    top: '35vh',
    position: 'absolute',
    paddingRight: '30px',
  },
  contentHigh: {
    height: '80vh',
    top: '14vh',
    position: 'absolute',
    paddingRight: '30px',
  },
  placeholder: {
    textAlign: 'center',
    alignSelf: 'center',
    margin: 'auto',
    marginTop: '20%',
    '-webkit-transform': 'scale(3)',
    '-moz-transform': 'scale(3)',
  },
  focusBox: {
    position: 'absolute',
    top: 100,
    width: '100%',
  },
  focusText: {
    fontSize: 120,
    fontFamily: "'Yanone Kaffeesatz', sans-serif",
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#fff',
  },
  customFocusText: {
    fontSize: 220,
    marginTop: -40,    
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#fff',
  },
  text: {
    color: '#fff',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '280px',
    fontSize: '3rem',
    fontFamily: "'Yanone Kaffeesatz', sans-serif",
  },
  largeText: {
    color: '#fff',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',    
    fontSize: '3rem',
    fontFamily: "'Yanone Kaffeesatz', sans-serif",
  },
  largeCancelledText: {
    color: '#e0201f',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',    
    fontSize: '3rem',
    fontFamily: "'Yanone Kaffeesatz', sans-serif",
  },
  headline: {
    color: '#fff',
    // borderBottomColor: '#86bc24',
    // borderBottomStyle: 'solid',
    // borderBottomWidth: 20,
    fontWeight: '800',
    textAlign: 'center',
    fontFamily: "'Yanone Kaffeesatz', sans-serif",
    paddingBottom: '20px',
    marginRight: '20px',
    maxWidth: '100%',
  },
  column: {
    flex: 1,
    maxWidth: '100%',
    height: '100vh',
  },
  name: {
    flex: 1,
    flexGrow: 0,
    maxWidth: '300px',
    minWidth: '200px',
    marginRight: '20px',
  },
  largeName: {
    marginTop: '120px',
    flex: 1,    
    textAlign: 'center',
    justifyContent: 'center',
    justifyContent: 'center',
  },
  names: {
    flex: 10,
    display: 'flex',
    maxWidth: '100%',
    flexWrap: 'wrap',
    marginLeft: '50px',
    maxHeight: 'calc(70vh - 150px)',
    marginTop: '70px',
    flexDirection: 'column',
  },
  namesLargeMarginTop: {
    flex: 10,
    display: 'flex',
    maxWidth: '100%',
    flexWrap: 'wrap',
    marginLeft: '50px',
    maxHeight: 'calc(70vh - 150px)',
    marginTop: '150px',
    flexDirection: 'column',
  },
  logoWrapper: {
    position: 'absolute',
    left: 'calc(50% - 137px)',
    width: '275px',
    top: '56px',
    paddingLeft: '20px',
    paddingRight: '20px',
    background: '#333',
  },
});

export default withStyles(styles)(Signage);
